// extracted by mini-css-extract-plugin
module.exports = {"content":"speakers-module--content--1mEx7","more":"speakers-module--more--fPOS2","speakers":"speakers-module--speakers--3kdWk"};